import { render, staticRenderFns } from "./warehouseDetail.vue?vue&type=template&id=af07676e&scoped=true"
import script from "./warehouseDetail.vue?vue&type=script&lang=js"
export * from "./warehouseDetail.vue?vue&type=script&lang=js"
import style0 from "./warehouseDetail.vue?vue&type=style&index=0&id=af07676e&prod&lang=css"
import style1 from "./warehouseDetail.vue?vue&type=style&index=1&id=af07676e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af07676e",
  null
  
)

export default component.exports